export const BUTTON_STYLE_MAIN =
  'disabled:bg-gray-300 w-auto h-8 px-2 py-1 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-800';
export const BUTTON_STYLE_MAIN_BLOCK = `block ${BUTTON_STYLE_MAIN}`;
export const BUTTON_STYLE_MAIN_FLEX = `inline-flex ${BUTTON_STYLE_MAIN}`;
export const BUTTON_STYLE_CANCEL =
  'disabled:bg-gray-300 w-auto h-8 px-2 py-1 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-gray-700 hover:bg-gray-900';
export const BUTTON_STYLE_CANCEL_BLOCK = `block ${BUTTON_STYLE_CANCEL}`;
export const BUTTON_STYLE_CANCEL_FLEX = `inline-flex ${BUTTON_STYLE_CANCEL}`;
export const BUTTON_STYLE_MODAL =
  'disabled:bg-gray-300 sm:w-auto w-full h-auto px-5 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-800';
export const BUTTON_STYLE_PUB =
  'disabled:bg-gray-300 block w-72 m-1 h-8 px-2 py-1 border border-transparent text-sm font-normal rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-800';
export const BUTTON_STYLE_CONSOLE = 'w-auto px-2 h-7 py-1 text-xs rounded-sm text-white bg-gray-700 hover:bg-gray-900';
export const BUTTON_STYLE_STREAM_PANEL =
  'inline-flex h-8 px-2 pt-[5px] w-full sm:w-32 px-2 py-1 border border-transparent text-sm font-normal rounded-full shadow-sm justify-center text-white bg-red-400 hover:bg-red-500';
export const BUTTON_STYLE_STREAM_PANEL_LEFT =
  'inline-flex h-8 px-2 pt-[5px] w-1/2 sm:w-16 px-2 py-1 border border-gray-500 text-sm font-normal rounded-l-full shadow-sm justify-center text-white bg-red-400 hover:bg-red-500';
export const BUTTON_STYLE_STREAM_PANEL_RIGHT =
  'inline-flex h-8 px-2 pt-[5px] w-1/2 sm:w-16 px-2 py-1 border border-gray-500 text-sm font-normal rounded-r-full shadow-sm justify-center text-white bg-red-400 hover:bg-red-500';
export const TEXT_INPUT_STYLE = 'bg-blue-100 disabled:bg-gray-300 w-full rounded-md shadow-sm outline';

export const MENU_CONFIG = 'relative inline-block text-left';
export const MENU_ITEM_CONFIG =
  'absolute right-auto left-0 sm:left-auto sm:right-0 mt-2 w-max origin-top-right sm:origin-top-left rounded-md bg-white shadow-lg ring-2 ring-black ring-opacity-10 focus:outline-none z-10';

export const PANEL_STYLE_MAIN =
  'flex flex-col rounded-md mx-auto sm:h-auto p-2 gap-2 bg-white content-start items-start overflow-visible';
export const PANEL_STYLE_STREAM =
  'flex flex-col h-auto w-auto sm:flex-row bg-gray-500 border-2 border-gray-500 rounded-md overflow-visible';

export const VIDEO_STYLE = 'bg-gray-100 flex-shrink-0';
export const VIDEO_STYLE_MIRRORED = `${VIDEO_STYLE} -scale-x-100`;
